import Gikam from '../../../core/gikam-core.js';
import grid from '../vue/grid.vue';
import Base from '../../base.js';
import Vue from 'vue';
import { GridStore } from './gridStore';
import jQuery from 'jquery';

let defaultOptions = {
    id: void 0,
    columns: [],
    url: void 0,
    customSearchData: void 0,
    width: null,
    fieldChangeFlag: true,
    customContent: void 0,
    //定义工具栏内容，其子组件可为form，button
    toolbar: [],
    //工具栏中按钮的对齐方式
    toolbarAlign: 'right',
    //是否可以拖动单元格宽度
    columnResize: true,
    //请求参数
    requestData: {},
    //默认排序字段
    order: {},
    //是否显示分页
    page: true,
    //当前第几页
    pageNum: 1,
    //每页显示数量
    pageSize: 50,
    //显示数据
    data: [],
    //高度
    height: 400,
    //总页数
    totalPage: 1,
    //数据总数
    totalRecord: 0,
    //是否显示整个表格
    showBody: true,
    //是否自动保存
    autoSave: true,
    //分页中，可选择的每页显示的数量
    pageList: [50, 100, 200],
    readonlyFields: {},
    //删除时，提示内容对应的格式化方法
    deleteFormatter: rows => rows.id,
    //启用时，提示内容对应的格式化方法
    activateFormatter: rows => rows.id,
    //是否显示通用查询
    genericQuery: false,
    genericQueryFields: [],
    //激活行时是否勾选复选框
    checkOnActive: true,
    //初始化时是否激活字段的change事件
    initTriggerChange: true,
    //激活行时是否取消其他行的选中
    checkOneOnActive: false,
    //分组字段
    group: {
        fields: [],
        formatter: Gikam.emptyFunction
    },
    //组件宽高是否填充满父元素
    fill: false,
    //快捷查询是否展开
    filterOpen: false,
    //是否开启快捷查询功能
    filter: true,
    //自定义功能组['refresh', 'import', 'export'],刷新、导入、导出
    generalButtonGroup: [],
    //允许的最大宽度，由父组件传值
    allowWidth: null,
    //初始化时是否请求数据
    initRequest: true,
    //编辑器是否可见，为true时，编辑器对应的表头颜色为蓝色，双击编辑器才可对其进行编辑
    editorInvisible: false,
    //控制单元格文本内容过长是否换行，
    textLineFeed: false,
    //控制勾选数量角标是否显示
    showCheckedNum: true
};

export default class Grid extends Base {

    constructor(options) {
        super();
        this.getListeners();
        this.canAutoSave = true;
        this.lastRequestData = null;
        this.validators = {};
        this.$window = options.$window;
        this.$parent = null;
        this.$notifyWindow();
        this.$initWindowParam(options);
        //用于存储选择隐藏的列
        this.hideColumnArray = [];
        this.initialize(options, defaultOptions).init();
    }

    /**
     * @description 在window中注册组件
     * @private
     * @memberof Grid
     */
    $notifyWindow() {
        if (this.$window) {
            this.$window.$addStoreComp('grid', this);
            this.$storeCompIndex = this.$window.$compStore.grid.length - 1;
        }
    }

    /**
     * @description 初始化从window组件传递的参数
     * @private
     * @memberof Grid
     */
    $initWindowParam(options) {
        if (this.$window && this.$window.$param && this.$storeCompIndex === 0) {
            options.requestData = Gikam.extend({}, this.$window.$param, options.requestData);
        }
    }

    getListeners() {
        this.listeners = {
            beforeRefresh: Gikam.emptyFunction,
            beforeLoad: Gikam.emptyFunction,
            cellClick: Gikam.emptyFunction,
            rendered: Gikam.emptyFunction,
            rowActive: Gikam.emptyFunction,
            select: Gikam.emptyFunction,
            unSelect: Gikam.emptyFunction,
            allSelect: Gikam.emptyFunction,
            unAllSelect: Gikam.emptyFunction,
            checkboxClick: Gikam.emptyFunction,
            afterChoose: Gikam.emptyFunction,
            loadSuccess: Gikam.emptyFunction,
            updated: Gikam.emptyFunction,
            beforeDelete: json => json,
            beforeActivate: json => json,
            beforeSuspend: json => json,
            beforeUpdate: (data, keys) => [data, keys]
        };
    }

    createModel() {
        let _this = this;
        let container = Gikam.createDom('div', this.options.renderTo);
        if (Gikam.isNotEmpty(this.options.data)) {
            this.initRowGroup(this.options.data);
        }
        this.store = new GridStore(this.options, this).store;
        this.cacheSelectItems(this.store.state.columns).done(() => {
            this.model = new Vue({
                el: container,
                store: this.store,
                render() {
                    return <grid ref="vm" options={this.options} onAllCheck={this.allCheckHandle}></grid>;
                },
                provide: {
                    grid: _this
                },
                components: {
                    grid
                },
                data() {
                    return {
                        options: _this.options
                    }
                },
                methods: {
                    allCheckHandle(checked) {
                        if (checked) {
                            _this.trigger('allSelect', _this.getSelections);
                        } else {
                            _this.trigger('unAllSelect', _this.getSelections);
                        }
                    }
                }
            });
            this.refresh();
            this.bindInstance(_this.model.$el);
            this.trigger('rendered');
            this.model.$nextTick(() => {
                this.notify();
            });
        });
    }

    setOptions(option) {
        Gikam.extend(true, this.options, option);
    }

    getOptions() {
        return Gikam.deepExtend(this.options);
    }

    //与上次查询条件进行比对，条件是否发生变化
    compareRequestData(requestData, lastRequestData) {
        if (!lastRequestData) {
            return true;
        }

        if (requestData.s !== lastRequestData.s) {
            return false;
        }

        let result = true;

        Gikam.each(requestData.f, function (key) {
            if (typeof this === 'object') {
                return true;
            }
            if (this !== lastRequestData.f[key]) {
                result = false;
                return false;
            }
        });

        Gikam.each(lastRequestData.f, function (key) {
            if (typeof this === 'object') {
                return true;
            }
            if (this !== requestData.f[key]) {
                result = false;
                return false;
            }
        });

        return result;

    }

    queryParams(options, pageNum, compare = true) {
        let _this = this;
        const state = this.store.state;
        this.options.requestData && Gikam.each(this.options.requestData, function (k, v) {
            if (Gikam.isEmpty(v)) delete _this.options.requestData[k];
        });
        const requestData = {
            f: Gikam.extend(true, {}, this.options.requestData, this.options.customSearchData, options),
            n: Gikam.isNotEmpty(pageNum) ? pageNum : (this.options.page ? state.pageNum : -1),
            s: state.pageSize
        };
        if (!Gikam.isEmptyObject(this.options.order)) {
            const orderArray = [];
            for (let key in this.options.order) {
                let order = {};
                order[key] = this.options.order[key];
                orderArray.push(order);
            }
            requestData.o = orderArray;
        }
        //条件发生变化，将页面重置为第一页
        //如果当前是第二页，条件发生变革回到第一页开始
        if (compare === true) {
            if (this.compareRequestData(requestData, this.lastRequestData) === false && requestData.n !== -1) {
                requestData.n = 1;
                this.options.pageNum = 1;
            }
            this.lastRequestData = requestData;
        }

        return Gikam.getJsonWrapper(requestData);
    }

    refreshByData(data) {
        if (this.options.initTriggerChange === false) {
            this.options.fieldChangeFlag = false;
        }
        const def = jQuery.Deferred();
        const _this = this;
        this.canAutoSave = false;
        const rows = this.trigger('beforeLoad', data.rows) || data.rows;
        this.store.state.fieldTypeMapper = data.columnTypeMap;
        this.initRowGroup(rows);
        this.options.data = rows;

        let total
        if (data.rows.length === rows.length) {
            total = Gikam.isNumber(data.total) ? data.total : rows.length;
        } else {
            total = rows.length;
        }
        this.store.commit('updateTotalRecord', total);

        this.model.$children[0].clean();
        this.model.$nextTick(() => {
            _this.canAutoSave = true;
            def.resolve();
            _this.trigger('loadSuccess', data.rows);
            _this.options.fieldChangeFlag = true;
        });
        return def;
    }

    getGroupValue(row) {
        let rowGroupValue = null;
        this.options.group.fields.forEach(field => {
            rowGroupValue += Gikam.getFieldValue(row, field);
        });
        return rowGroupValue;
    }

    /**
     * @description 初始化分组数据
     * @private
     * @param {Array} rows 表格数据
     * @returns
     * @memberof Grid
     */
    initRowGroup(rows) {
        if (Gikam.isEmpty(rows)) {
            return;
        }
        if (Gikam.isEmpty(this.options.group.fields)) {
            return;
        }
        const _this = this;
        let currentGroupValue;
        let currentGroupIndex = -1;
        for (let i = 0; i < rows.length; i++) {
            const rowGroupValue = _this.getGroupValue(rows[i]);
            if (rowGroupValue !== currentGroupValue) {
                currentGroupIndex++;
                currentGroupValue = rowGroupValue;
                rows.splice(i, 0,
                    Gikam.deepExtend({ _groupRow: true, _groupIndex: currentGroupIndex, _expand: true },
                        rows[i], { id: rows[i].id + '_group', $rowStyle: 'group' }));
            } else {
                Gikam.extend(rows[i], {
                    _parentGroupIndex: currentGroupIndex
                });
            }
        }
    }

    loadData(data) {
        this.refreshByData({ rows: data });
    }

    refresh(param) {
        if (this.model.$children[0].$refs.vs) {
            this.model.$children[0].$refs.vs.handleScroll();
        }
        let _this = this;
        let def = jQuery.Deferred();
        param && this.setOptions(param);
        if (this.trigger('beforeRefresh', this.options.requestData) === false) {
            def.fail();
            return;
        }
        if (this.options.url) {
            let model = _this.model.$children[0];
            model.loading = true;
            model.options.data = [];
            Gikam.post(this.options.url, this.queryParams()).done(r => {
                if (_this.options.initRequest === false) {
                    if (_this.options.requestData.scheme_only) {
                        delete _this.options.requestData.scheme_only;
                    }
                    _this.options.initRequest = true;
                }
                _this.refreshByData(r).done(() => {
                    def.resolve(_this);
                });
            }).always(() => {
                _this.model.$children[0].loading = false;
            });
        } else {
            _this.model.$nextTick(() => {
                _this.trigger('loadSuccess');
            });
            def.resolve();
        }
        return def;
    }

    refreshNoFieldChange(param) {
        this.options.fieldChangeFlag = false;
        let _this = this;
        this.refresh(param).done(() => {
            _this.options.fieldChangeFlag = true;
        });
    }

    getSelections() {
        //去除分组的行数据
        return this.model.$children[0].getSelections().filter(row => !row._groupRow);
    }

    getData() {
        let rows = [];
        jQuery.each(this.options.data, function () {
            let row = { ext$: {} };
            Gikam.each(this, (key, value) => {
                if (key.indexOf('ext$.') === 0) {
                    row.ext$[key.replace('ext$.', '')] = value;
                } else {
                    row[key] = value;
                }
            });
            rows.push(row)
        });
        return rows;
    }

    /**
     * @description 缓存所有下拉框选项值
     * @private
     * @param {Array} 需要筛选的字段配置参数
     * @returns
     * @memberof Grid
     */
    cacheSelectItems(columns) {
        let filterType = ['Select', 'SelectInput', 'ComboBox'];
        let codeArray = columns.filter(function (item) {
            return filterType.indexOf(Gikam.toInitialUpperCase(item.type || '')) > -1 && Gikam.isEmpty(item.items);
        });
        if (Gikam.isEmpty(codeArray)) {
            return jQuery.Deferred().resolve();
        }
        return Gikam.select.cacheItems(codeArray);
    }

    refreshRowByIndex(index, scroll) {
        const _this = this;
        //查询数据时，如果字段被清空，那么后台返回的字段值就不存在，
        //此时要添加这种字段为空
        const formatterData = (data) => {
            _this.options.columns.filter(item => item.field).forEach(function (item) {
                if (Gikam.isEmpty(Gikam.getFieldValue(data, item.field))) {
                    Gikam.setFieldValue(data, item.field, '');
                }
            });
            return data;
        };

        Gikam.post(this.options.url,
            this.queryParams({
                id_EQ: this.getData()[index].id
            }, 1, false)
        ).done((data) => {
            if (data.rows.length === 0) {
                _this.options.data.splice(index, 1);
            } else {
                Vue.set(_this.options.data, index, formatterData(data.rows[0]));
                if (scroll) {
                    _this.model.$children[0].$refs['vs'].scrollTo({
                        x: scroll.left,
                        y: scroll.top
                    });
                }
            }
        });
    }

    /**
     *
     * 通过id向后台发起请求,刷新此条数据
     * @param {String,Number} id
     * @returns
     * @memberof Grid
     */
    refreshRowById(id) {
        if (Gikam.isEmpty(id)) {
            return;
        }
        let index;
        Gikam.each(this.options.data, function (i) {
            if (this.id === id) {
                index = i;
                return true;
            }
        });
        this.refreshRowByIndex(index);
    }

    deleteRows(url) {
        let _this = this,
            options = {
                url: url,// 请求的地址
                confirm: {
                    msg: 'GIKAM.TIP.CONFIRM_TO_DELETE_FOLLOWING_ITEMS',// 确认弹出框中左侧的信息
                    title: 'GIKAM.TIP.CONFIRM_TO_DELETE',// 确认弹出框中的标题
                },
                formatter: function (row) {
                    return _this.options.deleteFormatter(row);
                },
                // 提交前处理json数据的方法
                beforeProcess: 'beforeDelete',
                // 调用的Html请求的方法
                method: 'del'
            };

        return _this.processRows(options);
    }

    activateRows(url) {
        let _this = this,
            options = {
                url: url,
                flag: {
                    name: 'activatedFlag',
                    expectedValue: '0',
                    unexpectedMsg: 'GIKAM.TIP.CHOOSE_DEACTIVATED_ITEM',
                },
                confirm: {
                    msg: 'GIKAM.TIP.WHETHER_TO_ACTIVATE_FOLLOWING_ITEMS',
                    title: 'GIKAM.TIP.CONFIRM_TO_ACTIVATE',
                },
                formatter: function (row) {
                    return _this.options.activateFormatter(row);
                },
                beforeProcess: 'beforeActivate'
            };

        return _this.processRows(options);
    }

    deactivateRows(url) {
        let _this = this;
        let options = {
            url: url,
            flag: {
                name: 'activatedFlag',
                expectedValue: '1',
                unexpectedMsg: 'GIKAM.TIP.CHOOSE_ACTIVATED_ITEM',
            },
            confirm: {
                msg: 'GIKAM.TIP.WHETHER_TO_DEACTIVATE_FOLLOWING_ITEMS',
                title: 'GIKAM.TIP.CONFIRM_TO_DEACTIVATE',
            },
            formatter: function (row) {
                return _this.options.activateFormatter(row);
            },
            beforeProcess: 'beforeActivate'
        };

        return _this.processRows(options);
    }

    suspendRows(url) {
        let _this = this,
            options = {
                url: url,
                flag: {
                    name: 'lastSuspendedFlag',
                    expectedValue: '0',
                    unexpectedMsg: 'GIKAM.TIP.CHOOSE_UNSUSPENDED_ITEM',
                },
                confirm: {
                    msg: 'GIKAM.TIP.WHETHER_TO_SUSPEND_FOLLOWING_ITEMS',
                    title: 'GIKAM.TIP.CONFIRM_TO_SUSPEND',
                },
                formatter: function (row) {
                    return _this.options.suspendFormatter(row);
                },
                beforeProcess: 'beforeSuspend',
            };

        return _this.processRows(options);
    }

    unsuspendRows(url) {
        let _this = this,
            options = {
                url: url,
                flag: {
                    name: 'lastSuspendedFlag',
                    expectedValue: '1',
                    unexpectedMsg: 'GIKAM.TIP.CHOOSE_SUSPENDED_ITEM',
                },
                confirm: {
                    msg: 'GIKAM.TIP.WHETHER_TO_UNSUSPEND_FOLLOWING_ITEMS',
                    title: 'GIKAM.TIP.CONFIRM_TO_UNSUSPEND',
                },
                formatter: function (row) {
                    return _this.options.suspendFormatter(row);
                },
                beforeProcess: 'beforeSuspend'
            };

        return _this.processRows(options);
    }

    processRows(options) {
        let def = jQuery.Deferred();
        if (Gikam.isEmpty(this.getSelections())) {
            Gikam.alert('GIKAM.TIP.CHOOSE_AT_LEAST_ONE_ITEM');
            return def;
        }
        let selectedRows = this.getSelections();
        if (options.flag) {
            let valid = true;
            selectedRows.forEach(function (row) {
                if (row[options.flag.name] !== options.flag.expectedValue) {
                    valid = false;
                }
            });
            if (!valid) {
                Gikam.alert(options.flag.unexpectedMsg);
                return def;
            }
        }
        let _this = this;
        let selectedRowsJson = selectedRows.map(row => {
            return { id: row.id };
        });
        let selectedHtml = selectedRows.reduce(function (total, row) {
            return total += '<div style="padding-top:5px;">' + (options.formatter ? options.formatter(row) : row.id) + '</div>';
        }, '');

        Gikam.create('confirm', {
            title: Gikam.propI18N(options.confirm.title),
            subTitle: Gikam.propI18N(options.confirm.msg),
            message: selectedHtml,
            height: 250,
            onYesClick: function () {
                _this.$window.showMask(true);
                Gikam[options.method ? options.method : 'put'](options.url, Gikam.getJsonWrapper(null, ['', (options.beforeProcess ? _this.trigger(options.beforeProcess, selectedRowsJson, selectedRows) : selectedRowsJson)])).done(function (r) {
                    if (options.gridRefresh !== false) {
                        _this.refresh();
                    }
                    def.resolve(r);
                }).always(function () {
                    _this.$window.closeMask();
                });
            }
        });

        return def;
    }

    /**
     * @description 导出excel
     * @public
     * @param {String} fileName         导出的文件名
     * @param {String} url              接口的url
     * @param {boolean} chooseColumns  是否筛选列
     * @memberof Grid
     */
    exportExcel(fileName, url, chooseColumns) {
        if (!url && !this.options.url) {
            return
        }
        let _this = this;
        chooseColumns ? this.createExportPage().done(function ({ chooseColumns }) {
            const formData = Gikam.getComp('export-excel-grid-form').getData();
            _this.exportRequest(fileName, url, chooseColumns, formData);
        }) : this.exportRequest(fileName, url);
    }

    /**
     * @description 创建导出列表
     * @private
     * @returns  jQuery.Deferred()
     * @memberof Grid
     */
    createExportPage() {
        let def = jQuery.Deferred();
        this.createExportModal();
        this.createExportLayout(def);
        return def
    }

    /**
     * @description 创建导出列表 中的modal
     * @private
     * @memberof Grid
     */
    createExportModal() {
        Gikam.create('modal', {
            title: 'GIKAM.MODAL.CHOOSE-EXPORT-COLUMNS',
            bodyStyle: {
                padding: '0 8px',
                margin: '-8px 0 0 0'
            },
            width: 360,
            height: 500
        });
    }

    /**
     * @description 创建导出列表 中的Layout
     * @private
     * @param {object} def  异步对象
     * @memberof Grid
     */
    createExportLayout(def) {
        const modal = Gikam.getLastModal()
        Gikam.create('layout', {
            renderTo: Gikam.getLastModal().window.$dom,
            center: {
                items: [
                    {
                        type: 'btnToolbar',
                        items: [
                            {
                                type: 'button',
                                text: '取消',
                                padding: '5px 16px',
                                onClick: function () {
                                    modal.close();
                                    def.reject();
                                }
                            },
                            {
                                type: 'button',
                                text: '确定',
                                class: 'blue',
                                padding: '5px 16px',
                                onClick: function () {
                                    const chooseColumns = Gikam.getComp('export-excel-grid').getSelections();
                                    if (Gikam.isEmpty(chooseColumns)) {
                                        return
                                    }
                                    def.resolve({ chooseColumns });
                                }
                            }
                        ]
                    },
                    {
                        type: 'grid',
                        id: 'export-excel-grid',
                        page: false,
                        genericQuery: false,
                        filter: false,
                        generalButtonGroup: false,
                        data: this.options.columns.filter(item => Gikam.isNotEmpty(item.title)),
                        toolbar: [
                            {
                                type: 'form',
                                titleWidthAuto: true,
                                autoSave: false,
                                id: 'export-excel-grid-form',
                                fields: [
                                    {
                                        title: '是否导出全部数据',
                                        type: 'simpleCheckbox',
                                        field: 'exportAll',
                                        refreshGrid: false,
                                        value: '1'
                                    },
                                    // {
                                    //     title: '是否异步导出',
                                    //     type: 'simpleCheckbox',
                                    //     field: 'isAsync',
                                    //     refreshGrid: false,
                                    //     value: '0'
                                    // }
                                ]
                            },
                        ],
                        columns: [
                            { checkbox: true },
                            { index: true },
                            {
                                title: '列名称',
                                field: 'title',
                                formatter(rowIndex, cellValue) {
                                    return Gikam.propI18N(cellValue);
                                }
                            }
                        ],
                        onLoadSuccess: function () {
                            this.model.$refs.vm.allChecked = true
                        }
                    }
                ]
            }
        })
    }

    /**
     * @description 生成下载链接 并下载文件
     * @public
     * @param {String} fileName         导出的文件名
     * @param {String} url              接口的url
     * @param {boolean} chooseColumns   需要导出的列组成的数组
     * @param {object} formData        导出参数 {exportAll，isAsync}
     * @memberof Grid
     */
    exportRequest(fileName, url, chooseColumns, formData) {
        const exportColumns = this.getExportColumns(chooseColumns);
        const isAsync = formData.isAsync === '1' ? true : false;

        const { params, header } = this.getExportParams(formData, fileName);
        Gikam.getLastModal() && Gikam.getLastModal().close();

        if (!isAsync) {
            Gikam.create('progress', {
                id: 'excel-progress',
                oldGrid: this,
                oldGridFunction: { fileName, url, chooseColumns, formData }
            });
        } else {
            Gikam.alert('文件生成中，请稍后在导出页面查看下载。');
        }
        this.sendExportRequire(url, params, exportColumns, header, isAsync);
    }

    /**
     * @description 获取需要导出的列
     * @private
     * @param {Array} filterArr     需要导出的列数组 [{field:''}...]
     * @memberof Grid
     */
    getExportColumns(filterArr) {
        const filterColmns = filterArr ? this.options.columns.filter(function (item) {
            return !!item.field && filterArr.some(function (filterItem) { return item.field === filterItem.field });
        }) : this.options.columns;

        const columns = filterColmns.map(function (item) {
            let filedDefine = {
                id: item.field,
                name: Gikam.propI18N(item.title),
                alignment: 'left'
            };

            if (item.type === 'select') {
                let optionsMapper = {};
                item.items.forEach(item => {
                    optionsMapper[item.value] = item.text;
                });
                filedDefine.options = optionsMapper;
            }

            return filedDefine;
        });

        return columns
    }

    /**
     * @description 获取导出文件的参数
     * @private
     * @param {String} fileName         导出的文件名
     * @param {object} formData        导出参数 {exportAll:''，isAsync:''}
     * @memberof Grid
     */
    getExportParams(formData, fileName) {
        const { exportAll, isAsync } = formData;
        //请求体参数
        const params = JSON.parse(this.queryParams()).p;
        if (exportAll === '1') {
            params.n = -1;
        }
        delete params.s;
        params.dt = this.options.name || fileName;

        //header参数
        const header = {
            GIKAM_EXCEL: '1',
            GIKAM_EXCEL_TABLE_NAME: this.options.name || fileName,
            GIKAM_REQUEST_MODE: 'sync'
        }
        if (isAsync) {
            header['GIKAM_REQUEST_MODE'] = 'async'
        }

        return { params, header }
    }

    /**
     * @description 发起导出请求
     * @private
     * @param {String} url              接口
     * @param {object} params           请求体参数
     * @param {object} header           请求头参数
     * @param {array}  columns           需要导出的列
     * @param {boolean} isAsync         是否异步导出
     * @memberof Grid
     */
    sendExportRequire(url, params, columns, header, isAsync) {
        Gikam.postText(url || this.options.url, Gikam.getJsonWrapper(params, ['', columns]), header).done(function () {
            if (!isAsync) {
                const progress = Gikam.getComp('excel-progress');
                progress.stopProgress();
                progress.changePercentageNum(100);
                setTimeout(() => {
                    progress.closeProgress();
                    const url = arguments[2].getResponseHeader('GIKAM_EXCEL_URL');
                    url && Gikam.download(Gikam.IFM_CONTEXT + decodeURIComponent(url));
                }, 300);
            }
        }).fail(function () {
            if (!isAsync) {
                const progress = Gikam.getComp('excel-progress');
                progress.stopProgress();
                progress.changeProgress('wrong');
            }
        })
    }

    getActivedRow() {
        return this.model.$children[0].getActiveRow();
    }

    setData(param, saveFlag = true) {
        if (Gikam.isEmpty(param.index) && Gikam.isEmpty(param.id)) {
            Gikam.error('No index or id was found when updating data');
        }
        this.canAutoSave = false;
        let row;
        let index = param.index;
        if (Gikam.isNotEmpty(param.index)) {
            row = this.options.data[param.index];
        } else {
            Gikam.each(this.options.data, function (i) {
                if (param.id === this.id) {
                    index = i;
                    row = this;
                    return false;
                }
            });
        }
        !row && Gikam.error('No updated data was found');
        Vue.set(this.options.data, index, Gikam.deepExtend(row, param));
        this.model.$nextTick(() => {
            this.canAutoSave = true;
            saveFlag && this.autoSave(param);
        });
    }

    /**
     *
     * @description 校验表格中数据是否满足规则，也可以校验指定行数据
     * @public
     * @param {Array} rows 校验指定的数据
     * @returns
     * @memberof Grid
     */
    validate(rows) {
        let _this = this;
        let error = [];
        const data = Gikam.isNotEmpty(rows) ? rows : this.getData();
        Gikam.each(data, function (rowIndex) {
            let rowValidateResult = true;
            let data = this;
            Gikam.each(_this.validators, function (field) {
                Gikam.each(this, function () {
                    let r = Gikam.validator[this.type](Gikam.getFieldValue(data, field), this.rule, field, data.id);
                    if (r.result === false) {
                        error.push({
                            field: field,
                            title: this.title,
                            message: r.message
                        });
                        rowValidateResult = false;
                    }
                });
                const childComp = _this.model.$children[0].$refs[(Gikam.isNotEmpty(rows) ? _this.getRowIndexById(data.id) : rowIndex) + field];
                if (childComp) {
                    childComp.validateResult = rowValidateResult;
                }
            });

            if (rowValidateResult === false) {
                return false;
            }
        });

        if (Gikam.isEmpty(error)) {
            return true;
        } else {
            this.showValidateMessage(error);
            return false;
        }
    }

    showValidateMessage(error) {
        let tpl = '<div class="validator-error-container">' +
            '<span class="error-title">' + Gikam.propI18N('GIKAM.TIP.INVALID_INPUT_FIELDS') + '</span>' +
            '<div class="error-zone">{errorMessage}</div>' +
            '</div>';
        let errorMessage = '';
        error.forEach(function (item) {
            errorMessage += '<div>' + '<span class="error-field-desc">' + Gikam.propI18N(item.title) + '</span>' + Gikam.propI18N(item.message) + '</div>'
        });

        Gikam.alert(Gikam.printf(tpl, {
            errorMessage: errorMessage,
        }), 200);
    }


    insert(url, data, param) {
        let _this = this;
        let def = jQuery.Deferred();
        let json = Gikam.getJsonWrapper(param, data ? ['', data] : null);
        let window = Gikam.getInstance(jQuery(this.model.$el).closest('.window'));
        window.showMask(true);
        Gikam.postText(url, json).done(function (id) {
            def.resolve(id);
            _this.refresh();
        }).always(function () {
            window.closeMask();
        });
        return def;
    }

    moveUp(url) {
        let selections = this.getSelections();
        let _this = this;
        let selectedIndex = this.model.$children[0].checkeds[0];

        if (Gikam.isEmpty(selections)) {
            Gikam.alert('GIKAM.TIP.MOVE_UP.NO_NODE_SELECTED');
            return false;
        }
        if (selections.length > 1) {
            Gikam.alert('GIKAM.TIP.MOVE_UP.MULTIPLE_NODES_SELECTED');
            return false;
        }
        if (selectedIndex === 0) {
            Gikam.alert('GIKAM.TIP.MOVE_UP.TOP_NODE_SELECTED');
            return false;
        }

        let window = Gikam.getInstance(jQuery(this.model.$el).closest('.window'));
        let data = this.getData();
        window.showMask(true);
        Gikam.put(Gikam.printf(url, {
            firstId: data[selectedIndex].id,
            secondId: data[selectedIndex - 1].id
        })).done(function () {
            _this.refresh().done(function () {
                _this.selectRowByIndex(selectedIndex - 1);
            });
        }).always(function () {
            window.closeMask();
        });

    }

    moveDown(url) {
        let selections = this.getSelections();
        let _this = this;
        let selectedIndex = this.model.$children[0].checkeds[0];
        let data = this.getData();

        if (Gikam.isEmpty(selections)) {
            Gikam.alert('GIKAM.TIP.MOVE_DOWN.NO_NODE_SELECTED');
            return false;
        }
        if (selections.length > 1) {
            Gikam.alert('GIKAM.TIP.MOVE_DOWN.MULTIPLE_NODES_SELECTED');
            return false;
        }
        if (selectedIndex === data.length - 1) {
            Gikam.alert('GIKAM.TIP.MOVE_DOWN.BOTTOM_NODE_SELECTED');
            return false;
        }

        let window = Gikam.getInstance(jQuery(this.model.$el).closest('.window'));
        window.showMask(true);
        Gikam.put(Gikam.printf(url, {
            firstId: data[selectedIndex].id,
            secondId: data[selectedIndex + 1].id
        })).done(function () {
            _this.refresh().done(function () {
                _this.selectRowByIndex(selectedIndex + 1);
            });
        }).always(function () {
            window.closeMask();
        });

    }

    selectRowByIndex(index) {
        this.model.$nextTick(() => {
            this.model.$refs.vm.$refs['checkbox_' + index][0].$el.click();
        });
    }

    activeRowByIndex(index) {
        const id = this.options.data[index].id;
        this.model.$nextTick(() => {
            this.model.$refs.vm.$refs['row-' + id][0].click();
        });
    }

    selectRowById(id) {
        let index = null;
        Gikam.each(this.options.data, function (i) {
            if (this.id === id) {
                index = i;
                return false;
            }
        });
        this.selectRowByIndex(index);
    }

    setReadonlyParam(isReadonly) {
        this.options.columns.filter(function (column) {
            return Gikam.isNotEmpty(column.editor);
        }).forEach(function (column) {
            column.editor = !isReadonly;
        });
    }

    setReadonly(isReadonly) {
        let readonly = Gikam.isEmpty(isReadonly) ? true : isReadonly;
        this.setReadonlyParam(readonly);
        this.refresh();
    }

    toFieldsReadonly(index, fields) {
        if (!Gikam.isNumber(index)) {
            Gikam.error(`index ${index} is not a validate number`);
        }
        this.model.$children[0].setFieldsReadonly(index, fields, true);
    }

    toFieldsEdit(index, fields) {
        if (!Gikam.isNumber(index)) {
            Gikam.error(`index ${index} is not a validate number`);
        }
        this.model.$children[0].setFieldsReadonly(index, fields, false);
    }

    hideBody() {
        this.options.showBody = false;
        return this;
    }

    showBody() {
        this.options.showBody = true;
        return this;
    }

    //追加内容到表格之后，此方法与hideBody配合使用，表格部分隐藏之后，再追加内容
    appendContent(content) {
        this.options.customContent = content;
        return this;
    }

    cleanData() {
        this.refreshByData({
            rows: [],
            total: 0,
            pageNumber: 0
        });
    }

    formatterPageList() {
        this.options.pageList = this.options.pageList.map(item => {
            return {
                value: item,
                text: item + '条/页'
            }
        });
    }

    initColumnSize(columns) {
        const containerWidth = (this.options.allowWidth || this.options.renderTo.clientWidth) - 20;
        const gridWidth = columns.reduce((total, field) => {
            let fieldWidth = field.width || 150;
            if (field.checkbox || field.index || field.radio) {
                field.width = fieldWidth = 50;
            }
            return total + fieldWidth;
        }, 0);

        if (gridWidth > containerWidth) {
            this.options.width = gridWidth;
            columns.filter(item => !item.width).forEach(field => {
                field.width = 150;
            });
        } else {
            const widthFields = columns.filter(item => item.width);
            const noWidthFields = columns.filter(item => !item.width);
            const widthFieldsTotal = widthFields.reduce((total, field) => { return total + field.width }, 0);
            const everyNoWidthFieldWidth = (containerWidth - widthFieldsTotal) / noWidthFields.length;
            noWidthFields.forEach((item, index) => {
                //最后一个字段的宽度是总宽度减去前面的宽度，防止空间计算误差
                if (index < noWidthFields.length - 1) {
                    item.width = everyNoWidthFieldWidth;
                }
            });
            this.options.width = containerWidth;
        }
    }

    watchColumns() {
        let columns = this.options.columns;
        let _this = this;
        Object.defineProperty(this.options, 'columns', {
            set(value) {
                columns = value;
                _this.initColumnSize(columns);
            },
            get() {
                return columns;
            }
        });
        this.initColumnSize(columns);
    }

    /**
     * @description 传入fields隐藏指定列
     * @public
     * @param {Array} 包含field字符串的数组
     * @memberof Grid
     */
    hideColumns(fields) {
        //获取当前columns数组
        let columns = this.options.columns.slice();

        //获取隐藏columns数组
        let tempHiddenColumns = this.hideColumnArray;

        //计算隐藏列原始位置
        let computedIndex = 0;
        let hiddenFields = [];
        //还原原始columns(避免循环调用隐藏指定列导致的位置错乱问题)
        for (let i = tempHiddenColumns.length - 1; i >= 0; i--) {
            //记录位置减空余位置，计算得出原始位置
            let index = this.hideColumnArray[i].columnsIndex - computedIndex;
            columns.splice(index, 0, this.hideColumnArray[i].field);
            hiddenFields.push(this.hideColumnArray[i].field.field);
            computedIndex += 1;
        }

        this.hideColumnArray = [];
        for (let i = columns.length - 1; i >= 0; i--) {
            //判断当前列是否为隐藏列
            if (columns[i].field && fields.concat(hiddenFields).indexOf(columns[i].field) !== -1) {
                //保存隐藏字段
                this.hideColumnArray.push({ columnsIndex: i, field: columns[i] });
                //删除当前渲染列
                columns.splice(i, 1);
            }
        }
        this.options.columns = columns;
    }

    /**
     * @description 通过传入field显示被隐藏的列
     * @public
     * @param {Array} 包含field字符串的数组
     * @memberof Grid
     */
    showColumns(fields) {
        //获取当前隐藏列数组
        let hidenColumns = this.hideColumnArray;
        //用于计算原始位置
        let computedIndex = 0;

        let colmuns = this.options.columns.slice();

        for (let i = hidenColumns.length - 1; i >= 0; i--) {
            if (fields.indexOf(hidenColumns[i].field.field) !== -1) {
                //记录位置减空余位置，计算得出原始位置
                let index = this.hideColumnArray[i].columnsIndex - computedIndex;
                colmuns.splice(index, 0, this.hideColumnArray[i].field);
                this.hideColumnArray.splice(i, 1);
            } else {
                computedIndex += 1;
            }
        }
        this.options.columns = colmuns;
        this.initColumnSize(colmuns);
    }

    /* 
    私有方法
    自动保存时使用，用于获取字段的type和items
     */
    getFieldInfoByData(data) {
        const fieldInfo = {};
        this.options.columns.forEach(columnOptions => {
            if (Gikam.isNotEmpty(data[columnOptions.field], true) && ['select', 'simpleCheckbox'].indexOf(columnOptions.type) > -1) {
                const options = {
                    type: columnOptions.type === 'simpleCheckbox' ? 'checkbox' : (columnOptions.type || 'text'),
                };
                if (columnOptions.type === 'select') {
                    options.items = columnOptions.items;
                }
                fieldInfo[columnOptions.field] = options;
            }
        });
        return fieldInfo;
    }

    autoSave(data) {
        if (!this.options.autoSave) {
            return;
        }
        if (this.trigger('beforeUpdate', data, Object.keys(data)) === false) {
            return;
        }
        if (Gikam.isEmpty(data.id)) {
            data.id = data.row ? data.row.id : this.options.data[data.index].id;
        }
        // 例如data:{id:1,field1:'123'},row:{ext${field1_ext$:{}}},则将field1的属性合并到data中
        const updateFields = Object.getOwnPropertyNames(data).filter(item => !['id', 'index', 'row'].includes(item));
        if (updateFields.length === 1 && data.row && data.row.ext$) {
            const preStr = updateFields[0] + '_ext$';
            const fieldData = data.row.ext$[preStr];
            if (fieldData) {
                for (let field in fieldData) {
                    if (field === '$field') {
                        data[fieldData[field]] = data[updateFields[0]];
                        delete data[updateFields[0]];
                    } else {
                        data[field] = fieldData[field];
                    }
                }
            }
        }
        delete data.index;
        delete data.row;
        Gikam.put(Gikam.IFM_CONTEXT + '/secure/gikam/actions/instant', Gikam.getJsonWrapper({ t: this.getFieldInfoByData(data) }, [this.options.service, [data]])).done(() => {
            this.trigger('updated', data, Object.keys(data));
        });
    }

    enableAutoSave() {
        this.canAutoSave = true;
    }

    disableAutoSave() {
        this.canAutoSave = false;
    }

    initGenericQueryFields() {
        if (this.options.genericQuery) {
            this.options.genericQueryFields = this.options.columns.filter(item => item.field && item.genericQuery).map(item => {
                return {
                    field: item.field
                }
            });
        }
    }

    initReadonly() {
        if (this.options.readonly === true) {
            this.options.columns.forEach(item => {
                item.readonly = true;
                item.editor = false;
            });
        }
    }

    registerValidators() {
        let _this = this;
        this.options.columns.filter(function (item) {
            return Gikam.isNotEmpty(item.validators);
        }).forEach(function (item) {
            _this.validators[item.field] = [];
            item.validators.forEach(function (name) {
                let validator = {};
                if (name.indexOf('strLength') === 0) {
                    Gikam.extend(validator, {
                        type: 'strLength',
                        rule: name.replace('strLength', '')
                    });
                } else if (name.indexOf('numRange') === 0) {
                    Gikam.extend(validator, {
                        type: 'numRange',
                        rule: name.replace('numRange', '')
                    });
                } else if (name.indexOf('remote') === 0) {
                    Gikam.extend(validator, {
                        type: 'remote',
                        rule: name.replace(/remote|\[|]/g, '')
                    });
                } else {
                    Gikam.extend(validator, {
                        type: name,
                    });
                }
                validator.title = item.title;
                _this.validators[item.field].push(validator);
            });
        });
        return this;
    }

    notify() {
        const pro = Gikam.createdComponent[this.options.id];
        if (pro) {
            pro.resolve(this);
            delete Gikam.createdComponent[this.options.id];
        }
    }

    setDefaultOptions(options) {
        Gikam.extend(true, defaultOptions, options.defaultOptions);
    }

    getCheckedRowIndex() {
        return this.model.$refs.vm.checkeds;
    }

    /**
     * @description 动态刷新表格列
     * @public
     * @param {Array} columns 新的字段数组
     * @memberof Grid
     */
    refreshColumns(columns) {
        this.canAutoSave = false;
        this.cacheSelectItems(columns).done(() => {
            this.initColumnSize(columns);
            this.store.commit('refreshColumns', columns);
            this.model.$nextTick(() => {
                this.canAutoSave = true;
            });
        });
    }

    /**
     * @description 获取快捷查询的条件
     * @private
     * @memberof Grid
     */
    getFilterRequestData() {
        const data = {};
        const filterData = Gikam.deepExtend(this.model.$refs.vm.$refs.header.filterData);
        for (let key in filterData) {
            if (Gikam.isNotEmpty(filterData[key])) {
                data[key] = filterData[key];
            }
        }
        return Object.keys(data).length === 0 ? null : data;
    }


    /**
     * @description 初始化请求查询条件
     * @private
     * @memberof Grid
     */
    initRequestData() {
        if (this.options.initRequest === false) {
            this.setOptions({
                requestData: {
                    //传此标志后台不进行数据查询
                    scheme_only: true
                }
            });
        }
    }

    /**
     * @description 通过id获取该条数据的索引
     * @param {String,Number} id 数据的id
     * @memberof Grid
     */
    getRowIndexById(id) {
        let index;
        Gikam.each(this.getData(), function (i) {
            if (this.id === id) {
                index = i;
                return false;
            }
        });
        return index;
    }

    /**
     * @description 获取单元格内组建
     * @public
     * @param {number/String} index 所在行
     * @param {String} field  所在列对应的field字段
     * @memberof Grid
     */
    getField(index, field) {
        return this.model.$refs.vm.$refs[index + '_' + this.getColumnsIndex(field)];
    }

    /**
     * @description 根据field 获取所在列的下表
     * @private
     * @param {String} field 需要查找的列的field字段
     * @memberof Grid
     */
    getColumnsIndex(field) {
        const columns = this.options.columns || [];
        for (let i = 0; i < columns.length; i++) {
            if (columns[i].field === field) {
                return i;
            }
        }
    }

    /**
     * @description 重新刷新Grid分组
     * @public
     * @param {分组参数} param {fields:[field1,field2],formatter:function(){}}
     * @memberof Grid
     */
    refreshGroup(param) {
        this.options.group = param;
        this.initRowGroup();
        this.refresh();
    }

    /**
     * @description 父组件尺寸变更时触发
     * @private 
     * @param {object} size {width:100,height:100}
     * @memberof Tab
     */
    onResize() {
        this.options.allowWidth = this.$parent.$width;
        this.model.$children[0].handleBtnMore();
    }

    init() {
        this.registerValidators();
        this.initRequestData();
        this.watchColumns();
        this.formatterPageList();
        this.initGenericQueryFields();
        this.initReadonly();
        this.createModel();
        this.watchColumns();
    }
}

